import { ROLE_IN_RELATIONSHIP_OPTIONS } from '../ROLE_IN_RELATIONSHIP_OPTIONS';
import { RoleInRelationshipOptionIdType } from '../types';

export const getRoleInRelationshipTitleById = (
  id: RoleInRelationshipOptionIdType | null | undefined,
): string | null => {
  if (!id) return null;
  return (
    ROLE_IN_RELATIONSHIP_OPTIONS.find((option) => option.id === id)?.title ||
    null
  );
};

const DEFAULT: RoleInRelationshipOptionIdType = 'equal';
export const getRoleInRelationshipIdByTitle = (
  title: string | null | undefined,
  withDefault = false,
): RoleInRelationshipOptionIdType | null => {
  const id = ROLE_IN_RELATIONSHIP_OPTIONS.find(
    (option) => option.title === title,
  )?.id;
  if (id) {
    return id;
  }
  if (withDefault) {
    return DEFAULT;
  }
  return null;
};
